export const ActiveStyle = {
    fontWeight: 'bold',
    borderLeftWidth: '4px',
    borderColor: 'green.500',
};
